export function formatDateByType(dateString, type = 'DD/MM/YYYY') {
  const dateValue = dateString;
  if (!dateValue) return '';
  const date = new Date(dateValue);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  const abbreviatedMonth = new Intl.DateTimeFormat('pt-BR', {
    month: 'short',
  })
    .format(date)
    .toUpperCase()
    .substring(0, 3);

  switch (type) {
    case 'DD/MM/YYYY': {
      return `${day
        .toString()
        .padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`;
    }
    case 'DD/MM': {
      return `${day
        .toString()
        .padStart(2, '0')}/${month.toString().padStart(2, '0')}`;
    }
    case 'DD': {
      return `${day.toString().padStart(2, '0')}`;
    }
    case 'ABBREVIATEDMONTH/YYYY': {
      return `${abbreviatedMonth}/${year}`;
    }
    default: {
      return date;
    }
  }
}
